export default "__VITE_ASSET__BvRoa$a4__"